import { useMemo } from "react";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyListQuery";
import { ArchivedFilterEnum } from "web_myplann/Infrastructure/Api/Api";
import { availableCategoriesByContractState } from "web_myplann/Portfolio/Helpers/availableCategoriesByContractState";
import type { AvailableCategoriesByContractState } from "web_myplann/Portfolio/Types/AvailableCategoriesByContractState";

export const useAvailableCategoriesByContractState = ():
	| AvailableCategoriesByContractState
	| undefined => {
	const { data: portfolioList } = usePortfolioListQuery(
		undefined,
		undefined,
		ArchivedFilterEnum.All,
	);
	const { data: propertyList } = usePropertyListQuery(
		undefined,
		undefined,
		ArchivedFilterEnum.All,
	);

	return useMemo(
		() =>
			portfolioList && propertyList
				? availableCategoriesByContractState(
						portfolioList.data,
						propertyList.data,
					)
				: undefined,
		[portfolioList, propertyList],
	);
};
